import { render, staticRenderFns } from "./promote-manager.vue?vue&type=template&id=7a1ca962"
import script from "./promote-manager.vue?vue&type=script&lang=js"
export * from "./promote-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports